module.exports = __webpack_public_path__ + "img/equipos-moviles-gal-2.042a8cc1.jpg";